// In footeraccordion.jsx
export const FooterAccordion = () => {
  // component code
};
